<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md1>
        <span class="display-2 font-weight-light">
          {{ itemActivo.Letra }}
        </span>
      </v-flex>
      <v-flex xs12 md4 offset-md3>
        <Fecha
          label="Fecha"
          :fecha="itemActivo.Fecha"
          :rules="rules"
          :readonly="readonly"
          @seleccionarItem="seleccionarFecha"
        />
      </v-flex>
      <v-flex
        v-if="itemActivo.Id_Talonario == null || itemActivo.Id_Talonario == 0"
        xs12
        md4
      >
        <v-text-field
          label="Número*"
          v-model="itemActivo.NumeroActual"
          v-mask="'####-########'"
          :rules="rules"
          @change="seleccionarNumeroActual"
        ></v-text-field>
      </v-flex>
      <v-flex v-else xs12 md4 class="text-right">
        <span class="title"> Nº {{ iPrefijoNumero }} </span>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4 offset-md4>
        <v-select
          label="Comprobante*"
          v-model="itemActivo.Id_TipoComprobante_Talonario"
          :items="items"
          item-value="Id_TipoComprobante_Talonario"
          item-text="NombreTipoComprobante"
          :rules="rules"
          :readonly="readonly"
          :loading="loading"
          solo
          @change="buscarNumeroActual"
        >
          <template v-slot:no-data
            >No hay datos para mostrar</template
          >
          <template v-slot:progress>
            <v-progress-circular
              color="blue"
              indeterminate
            ></v-progress-circular>
          </template>
        </v-select>
      </v-flex>
      <v-flex xs12 md4>
        <SelectCondicionVenta
          :id_TipoComprobante="itemActivo.Id_TipoComprobante"
          :model="itemActivo.Id_CondicionVenta"
          :rules="rules"
          :readonly="readonly"
          @seleccionarItem="seleccionarCondicionVenta"
        />
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </div>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import moment from "moment";
import Mensaje from "@/components/Mensaje";
import Fecha from "@/components/Fecha";
import SelectCondicionVenta from "@/components/Sistema/SelectCondicionVenta";
export default {
  name: "SelectTipoComprobanteNumeroRecibido",
  props: {
    nombreModulo: String,
    id_PuntoVenta: Number,
    letra: String,
    numero: String,
    rules: {},
    readonly: Boolean
  },
  components: {
    SelectCondicionVenta,
    Mensaje,
    Fecha
  },
  data() {
    return {
      itemVacio: {
        Fecha: "",
        Id_TipoComprobante_Talonario: 0,
        NombreModulo: "",
        Id_TipoComprobante: 0,
        NombreTipoComprobante: "",
        Letra: "",
        NombrePuntoVenta: "",
        PrefijoPuntoVenta: 0,
        Id_Talonario: 0,
        NumeroActual: "",
        Id_CondicionVenta: 0,
        NombreCondicionVenta: "",
        Id_Caja: 0,
        FechaCaja: "",
        TurnoCaja: 0,
        NombreEmpleadoCaja: ""
      },
      itemActivo: {},
      items: [],
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      loading: false
    };
  },
  watch: {
    letra: function(valor) {
      this.itemActivo.Letra = valor;
    },
    numero: function(valor) {
      this.itemActivo.NumeroActual = valor;
    }
  },
  computed: {
    iPrefijoNumero() {
      let texto = "";
      if (
        this.itemActivo.PrefijoPuntoVenta != undefined &&
        this.itemActivo.NumeroActual != undefined
      ) {
        texto +=
          String(this.itemActivo.PrefijoPuntoVenta).padStart(4, "0") +
          "-" +
          this.itemActivo.NumeroActual.padStart(8, "0");
      }
      return texto;
    }
  },
  created() {
    eventBus.$on(
      "inicializarSelectTipoComprobanteNumeroRecibido",
      this.inicializar
    );
    eventBus.$on(
      "seleccionarSelectTipoComprobanteNumeroRecibido",
      this.seleccionar
    );
  },
  beforeDestroy() {
    eventBus.$off(
      "inicializarSelectTipoComprobanteNumeroRecibido",
      this.inicializar
    );
    eventBus.$off(
      "seleccionarSelectTipoComprobanteNumeroRecibido",
      this.seleccionar
    );
  },
  methods: {
    ejecutarAccion(accion) {
      if (accion == "CancelarMensaje") this.mostrarMensaje(false);
    },
    inicializar() {
      this.limpiar();
      this.seleccionar();
    },
    limpiar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      this.itemActivo.Fecha = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    },
    seleccionar() {
      this.listarTipoComprobantePorModulo();
    },
    listarTipoComprobantePorModulo() {
      this.loading = true;
      HttpHelper.get("TipoComprobante_Talonario/ListarPorModulo", {
        nombreModulo: this.nombreModulo,
        id_PuntoVenta: this.id_PuntoVenta,
        letra: this.letra
      })
        .then(response => {
          this.items = response.data;
          if (this.items.length > 0) {
            this.itemActivo.Id_TipoComprobante_Talonario = this.items[0].Id_TipoComprobante_Talonario;
            this.buscarNumeroActual();
          } else {
            this.mostrarMensaje(
              true,
              "Mensaje",
              "Caja Cerrada",
              "Debe agregar una nueva planilla de caja para continuar."
            );
          }
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarNumeroActual() {
      if (
        this.itemActivo.Id_TipoComprobante_Talonario != undefined &&
        this.itemActivo.Id_TipoComprobante_Talonario > 0
      ) {
        let ind = this.items.findIndex(
          x =>
            x.Id_TipoComprobante_Talonario ==
            this.itemActivo.Id_TipoComprobante_Talonario
        );
        this.itemActivo.NombrePuntoVenta = this.items[ind].NombrePuntoVenta;
        this.itemActivo.NombreModulo = this.items[ind].NombreModulo;
        this.itemActivo.Id_TipoComprobante = this.items[ind].Id_TipoComprobante;
        this.itemActivo.NombreTipoComprobante = this.items[
          ind
        ].NombreTipoComprobante;
        this.itemActivo.Id_Caja = this.items[ind].Id_Caja;
        this.itemActivo.Letra = this.items[ind].Letra;
        this.itemActivo.PrefijoPuntoVenta = this.items[ind].PrefijoPuntoVenta;
        this.itemActivo.Id_Talonario = this.items[ind].Id_Talonario;
        if (this.itemActivo.Id_Talonario == null)
          this.itemActivo.NumeroActual = "";
        else
          this.itemActivo.NumeroActual = String(this.items[ind].NumeroActual);
        this.itemActivo.FechaCaja = this.items[ind].FechaCaja;
        this.itemActivo.TurnoCaja = this.items[ind].TurnoCaja;
        this.itemActivo.NombreEmpleadoCaja = this.items[ind].NombreEmpleadoCaja;
        this.$emit("seleccionarTipoComprobante", this.itemActivo);
      }
    },
    seleccionarNumeroActual() {
      this.$emit("seleccionarTipoComprobante", this.itemActivo);
    },
    seleccionarCondicionVenta(item) {
      this.itemActivo.Id_CondicionVenta = item.Id_CondicionVenta;
      this.itemActivo.NombreCondicionVenta = item.NombreCondicionVenta;
      this.$emit("seleccionarCondicionVenta", this.itemActivo);
    },
    seleccionarFecha(item) {
      this.itemActivo.Fecha = item.Fecha;
      this.$emit("seleccionarTipoComprobante", this.itemActivo);
    },
    mostrarError(error) {
      let detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
